export const RenameIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...(props ?? {})}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1082_42346)">
        <path
          d="M10.8562 12.5798C10.6726 12.7629 10.4492 12.901 10.2034 12.9833L7.84177 13.7705C7.67152 13.8273 7.49322 13.8562 7.31374 13.8562C6.86765 13.8562 6.44827 13.6825 6.13288 13.367C5.68271 12.9168 5.52818 12.262 5.7295 11.6581L6.51674 9.29656C6.59897 9.05073 6.73704 8.8273 6.92012 8.6438L12.021 3.54297H2.04102C0.9156 3.54297 0 4.45857 0 5.58398V17.459C0 18.5844 0.9156 19.5 2.04102 19.5H13.916C15.0414 19.5 15.957 18.5844 15.957 17.459V7.47901L10.8562 12.5798Z"
          fill={props?.color ?? '#5B5B5B'}
        />
        <path
          d="M7.70735 9.43105C7.64625 9.49215 7.60021 9.56664 7.5729 9.64862L6.78566 12.0102C6.75298 12.1083 6.74825 12.2135 6.77201 12.3141C6.79576 12.4147 6.84705 12.5067 6.92015 12.5798C6.99324 12.6529 7.08524 12.7042 7.18584 12.728C7.28644 12.7517 7.39167 12.747 7.48974 12.7143L9.85138 11.9271C9.93336 11.8998 10.0079 11.8538 10.069 11.7927L17.0227 4.83899L14.6611 2.47738L7.70735 9.43105ZM17.6786 0.771724C17.3163 0.409425 16.7289 0.409425 16.3666 0.771724L15.4482 1.69014L17.8099 4.05178L18.7283 3.13336C19.0906 2.77107 19.0906 2.18366 18.7283 1.82136L17.6786 0.771724Z"
          fill={props?.color ?? '#5B5B5B'}
        />
      </g>
    </svg>
  );
};
